import { apiService } from "../api";

const ENDPOINTS = {
  CUSTOM_SCRIPT: "/custom-script",
  CUSTOM_SCRIPT_BY_WEBSITE: (websiteId, type) => `/custom-script/${websiteId}/type/${type}`,
};

class CustomScriptService {
  async getAll(websiteId, type) {
    return apiService.get(ENDPOINTS.CUSTOM_SCRIPT_BY_WEBSITE(websiteId, type));
  }

  async create(data) {
    return apiService.post(ENDPOINTS.CUSTOM_SCRIPT, data);
  }

  async update(data) {
    return apiService.put(ENDPOINTS.CUSTOM_SCRIPT, data);
  }

  async delete(id) {
    return apiService.testDelete(ENDPOINTS.CUSTOM_SCRIPT, { data: { id } });
  }
}

export const customScriptService = new CustomScriptService();
